<script>
import { computed, defineComponent, ref, watch } from 'vue'
import FormItem from '@/components/Input/FormItem.vue'
import Price from './Price/index.vue'
import BundleProductInput from '../BundleProductInput/index.vue'

export default defineComponent({
  components: {
    FormItem,
    Price,
    BundleProductInput,
},
  props: {
    business: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const model = ref(props.value)
    watch(() => props.value, (value) => {
      model.value = value
    }, { immediate: true })
    const item = computed({
      get() {
        return model.value.catalogs.items[0] || {}
      },
      set(value) {
        model.value.catalogs.items[0] = value
      },
    })

    return {
      model,
      item,
    }
  },
})
</script>

<template>
  <div>
    <div>
      <div style="max-width: 600px">
        <a-row type="flex" :gutter="16">
          <a-col :lg="{ span: 12 }">
            <FormItem rules="required|no_space" :label="$t('SKU')">
              <a-input 
                v-model="item.sku"
                class="h-48px"
              />
            </FormItem>
          </a-col>
          <a-col :lg="{ span: 12 }">
            <FormItem rules="" :label="$t('product.factory_sku')">
              <a-input 
                v-model="item.factory_sku"
                class="h-48px"
              />
            </FormItem>
          </a-col>
        </a-row>
      </div>

      <Price
        v-model="item.price"
        :business="business"
        :units="model.units"
        :vat-type="model.detail.vat_type" 
        class="mb-5"
      />
    </div>

    <BundleProductInput
      v-model="model.catalogs.bundling"
      :product="value"
      :business="business"
      class="mb-3"
    />
  </div>
</template>
